/**
 * Batas stok untuk item keranjang produk fisik (selaras dengan shop/[id].js).
 */

export function isDigitalCartItem(productData) {
  if (!productData) return false;
  const flag =
    productData.is_digital_product ?? productData.is_digital;
  return flag === true || flag === 1 || flag === "1" || flag === "true";
}

export function getVariantStockValue(variant) {
  if (!variant) return 0;

  const direct =
    variant.quantity ??
    variant.total_stock ??
    variant.totalStock ??
    variant.stock ??
    0;

  if (typeof direct === "object" && direct) {
    const nested =
      direct.quantity ?? direct.total ?? direct.stock ?? direct.value ?? 0;
    const n = Number(nested);
    return Number.isFinite(n) ? n : 0;
  }

  const n = Number(direct);
  return Number.isFinite(n) ? n : 0;
}

function toBooleanFlag(value) {
  if (typeof value === "boolean") return value;
  if (typeof value === "number") return value === 1;
  if (typeof value === "string") {
    const normalized = value.trim().toLowerCase();
    return normalized === "1" || normalized === "true";
  }
  return false;
}

export function isPreorderUnlimitedStock(variant, product) {
  const isPreorder = toBooleanFlag(
    variant?.is_preorder ?? variant?.isPreorder ?? product?.is_preorder,
  );
  const isUnlimitedStock = toBooleanFlag(
    variant?.is_unlimited_stock ??
      variant?.isUnlimitedStock ??
      product?.is_unlimited_stock,
  );
  return isPreorder && isUnlimitedStock;
}

export function resolveVariantFromMap(item, variantMap) {
  if (!variantMap || !item?.productData) return null;
  const slug = item.productData.slug ?? item.productData.uuid;
  if (!slug) return null;
  const variants = variantMap[slug] || [];
  return (
    variants.find((x) => item.variantUuid && x.uuid === item.variantUuid) ||
    variants.find(
      (x) =>
        item.variantId != null &&
        (x.id === item.variantId || String(x.id) === String(item.variantId)),
    ) ||
    null
  );
}

/**
 * Stok maksimum untuk produk fisik; null = tanpa batas (digital / unlimited / data tidak cukup).
 * @param {object} item - entri cart { productData, variantData, variantUuid, variantId }
 * @param {Record<string, array>|null|undefined} variantMap - opsional, hasil fetch variants per slug
 */
export function getPhysicalMaxQuantity(item, variantMap) {
  if (!item || isDigitalCartItem(item.productData)) return null;

  const product = item.productData || {};
  const fromMap = resolveVariantFromMap(item, variantMap);
  const variant = fromMap || item.variantData;
  if (!variant) return null;

  if (isPreorderUnlimitedStock(variant, product)) return null;

  const stock = getVariantStockValue(variant);
  if (stock > 0) return stock;
  return null;
}
